<template>
    <vx-card title="Products"> </vx-card>
</template>

<script>
import { textFormat } from '@/mixins/TextFormat'

export default {
    name: 'CommissionListCard',
    mixins: [textFormat],
    props: [],
    components: {},
    data() {
        return {
            show: {},
        }
    },
    computed: {},
    methods: {},
}
</script>
